<template>
  <div class="placePicker">
    <van-popup v-model="showPlacePicker" position="bottom">
      <van-area :area-list="areaList" :value="value" @confirm="confirm" @cancel="modelClose=false" />
    </van-popup>
  </div>
</template>

<script>
import service from '@/request/api';
// 导入api接口
export default {
  name: 'AddressSelect',
  data() {
    return {
      modelClose: this.showPlacePicker,
      areaList: {},
      value: '110101',
    };
  },
  props: ['showPlacePicker'],
  watch: {
    showPlacePicker(value) {
      console.log(value);
      this.modelClose = value;
    },
    modelClose(value) {
      this.$emit('changeShowModal', value);
    },
  },
  mounted() {
    console.log(this.modelClose);
    service.CommonForms.getAreaList().then((res) => {
      this.areaList = res.data;
    }).catch((e) => {
      console.log(e);
    });
  },
  methods: {
    confirm(value) {
      this.$emit('comfirmPlace', value); // 用来触发父组件定义的@input
    },
  },
};
</script>
